import { useEffect } from "react";
import { Link } from "react-router-dom";
function Business() {
useEffect(() => {
window.scrollTo(0, 0);
}, []);
  return (
    <div className="page">
      <div className="sub business">
        <div className="visual">
          <div className="dimBg2"></div>
          <div className="container">
            <div className="text">
              언제나 함께 하는 사람들
              <br />
              KNO1996입니다.
            </div>
          </div>
        </div>
        <div className="container">
            <div className="subPageTitle">
                비즈니스
            </div>
            <div className="businessWrap">
                <div className="item">
                <div className="dimBg2"></div>
                    <div className="text">
                        클라우드 / 가상화
                    </div>
                </div>
                <div className="item">
                <div className="dimBg2"></div>
                    <div className="text">
                        데이터센터
                    </div>
                </div>
                <div className="item">
                <div className="dimBg2"></div>
                    <div className="text">
                        통합 유지보수
                    </div>
                </div>
                <div className="item">
                <div className="dimBg2"></div>
                    <div className="text">
                        스토리지 솔루션 구축
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  );
}
export default Business;
